import React, {FunctionComponent, useState, ReactElement} from 'react';
import {Container, _ReactPixi} from '@inlet/react-pixi';
import {utilArray} from '@gongxigames/framework/lib/util/utilArray';
import {UpdateManager} from '@gongxigames/framework/core';
import {Arrows, DotButtons, Slide, SlideProps, SlidesPresentation} from '@gongxigames/framework/slot/modules/loadingScreen';
import {useTimer} from '@gongxigames/framework/core/fragments/react';

export type SlidesProps = _ReactPixi.IContainer & {
    updateManager: UpdateManager;
    dotsHide?: boolean;
    dotsPosition?: [number, number];
    arrowsHide?: boolean;
    arrowsPosition?: [number, number];
};

function getChildren(children: React.ReactNode): undefined | ReactElement<SlideProps>[] {
    if (children && !Array.isArray(children)) {
        children = [children];
    }

    return children as any;
}

function isAllSlides(children: ReactElement[] = []): boolean {
    return children.every(item => item.type === Slide);
}

export const Slides: FunctionComponent<SlidesProps> = (props) => {
    const [activeIndex, setIndex] = useState(0);
    const {dotsHide, arrowsHide, dotsPosition, arrowsPosition, updateManager} = props;
    const children = getChildren(props.children);
    const wait = children?.[activeIndex].props.time || 8000;

    useTimer(() => {
        setIndex(utilArray.normalizeIndexFromReelStrip(children!.length, activeIndex + 1));
    }, updateManager, wait, true, [activeIndex]);

    if (!children || !isAllSlides(children)) {
        throw new Error('All children elements should be <Slides.Slide/> components! Or <Slides/> - is empty!');
    }

    const arrows = arrowsHide ?
        null :
        <Arrows slides={children.length} activeIndex={activeIndex} setIndex={setIndex} arrowsPosition={arrowsPosition} />;

    const dots = dotsHide ?
        null :
        <DotButtons slides={children.length} activeIndex={activeIndex} setIndex={setIndex} dotsPosition={dotsPosition} />;

    return (
        <Container name='Slides' {...props}>
            <SlidesPresentation activeIndex={activeIndex} slides={children} updateManager={updateManager} />
            {arrows}
            {dots}
        </Container>
    );
};
